import axios from "axios";
import GetServerAddress from "../../../../functions/GetServerAddress";

export function ShopifySaleSendAttendeeDataToMongoDB2025Register(
  data,
  logoutStudent
) {
  const postData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "ShopifySaleSendAttendeeDataToMongoDB2025Register",
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logoutStudent();
        return; // Stop further execution in case of invalid auth token
      }
      // Alert for successful POST request
      window.alert(response.data.message);
    } catch (error) {
      console.error("Error Posting data: ", error);
      // Alert for failed POST request
      window.alert(
        "Error Posting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  postData();
} // Empty dependency array means this effect runs only once
